export default __webpack_public_path__ + "static/media/img-warehouse_4.480cd1df.jpg";